import { chakra } from '@stockx/ui';

export const MobileNavBar = chakra('div', {
  baseStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: { base: '100%', md: 'auto' },
  },
});

export const HeaderNavToggle = chakra('button', {
  baseStyle: {
    display: { base: 'block', md: 'none' },
    position: 'relative',
    width: '50px',
    float: 'right',
    margin: 0,
    padding: '9px 10px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: 'transparent',
    backgroundImage: 'none',

    ' .sandwich-line': {
      display: 'block',
      width: '22px',
      height: '2px',
      marginBottom: 1,
      borderRadius: '1px',
      background: 'neutral.500',
      ':last-child': {
        marginBottom: 0,
      },
    },
  },
});

export const StyledSrOnly = chakra('span', {
  baseStyle: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0,
  },
});
